import {combineReducers} from 'redux'
import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import Immutable from 'seamless-immutable'
import {createNewItem} from 'reducers/purchasingContext/selected'
import purchaseInvoiceItemDrawer from './purchaseInvoiceItemDrawer'
import {
  asyncMarkInvoiceAsPosted,
  unmarkPurchaseInvoiceAsPosted,
  updateAccountingInvoiceId,
} from 'helpers/accounting'

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_ATTEMPT:
      return true
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_SUCCESS:
      return false
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_FAILURE:
      return false
    case types.PURCHASING_PURCHASE_INVOICE_ADD_SUCCESS:
      return false
    default:
      return state
  }
}

export const purchaseInvoice = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_ATTEMPT:
      return null
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_SUCCESS:
      return action.data
    case types.PURCHASING_LOAD_PURCHASE_INVOICE_FAILURE:
    case types.PURCHASING_UNLOAD_PURCHASE_INVOICE:
      return null
    case types.PURCHASING_PURCHASE_INVOICE_ADD_SUCCESS:
      return action.data
    case types.PURCHASING_PURCHASE_INVOICE_UPDATE_SUCCESS:
      return {
        ...state,
        ...action.data.result,
      }
    case types.ACCOUNTING_PURCHASE_INVOICE_POST_ASYNC_SUCCESS:
      return asyncMarkInvoiceAsPosted(state, action)
    case types.PURCHASE_INVOICING_UNMARK_POSTED_SUCCESS:
      return unmarkPurchaseInvoiceAsPosted(state, action)
    case types.ACCOUNTING_INVOICE_SHOW_POST_REPORT:
      return updateAccountingInvoiceId(state, action)
    default:
      return state
  }
}

export const purchasingContextPurchaseInvoiceItemsPivotTableKey = 'purchasingContext.selectedPurchaseInvoice.items'

export default combineReducers({
  isLoading,
  purchaseInvoice,
  purchaseInvoiceItemDrawer,
  items: createPivotTableReducer({
    key: purchasingContextPurchaseInvoiceItemsPivotTableKey,
    defaultSortColumn: 'itemId',
    defaultSortDirection: Immutable('asc'),
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: createNewItem,
  }),
})
